import React from "react";
import logo from "../../assets/img/loader.png";
import { login } from "../../services/authService";
import { toastError, toastBigError } from "../utils/toasts";
import { usePageLoading } from "hooks/usePageLoading";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col,
  Row,
} from "reactstrap";

const Login = (props) => {
  const doneLoading = usePageLoading(props);
  const [firstFocus, setFirstFocus] = React.useState(false);
  const [lastFocus, setLastFocus] = React.useState(false);
  const [data, setData] = React.useState({
    username: "",
    password: "",
  });

  React.useEffect(() => {
    document.body.classList.add("login-page");
    // document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    doneLoading(); // no hay datos que traer
    return function cleanup() {
      document.body.classList.remove("login-page");
      // document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  const forgotPassword = (event) => {
    event.preventDefault();
    window.location = "/recuperar";
  };

  const doLogin = async (event) => {
    event.preventDefault();
    try {
      const response = await login(data.username, data.password);
      if (response.data.success) {
        localStorage.setItem("token", response.data.token);
        window.location = "/";
      } else {
        toastBigError("Acceso Denegado", "e-mail o contraseña incorrectos");
      }
    } catch {
      toastError("Error de Conexión");
    }
  };

  const handleChange = ({ currentTarget: input }) => {
    const newData = { ...data };
    newData[input.name] = input.value;
    setData(newData);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      doLogin(event);
    }
  };

  return (
    <>
      <div className="page-header header-filter">
        <div
          className="page-header-image"
          style={{
            backgroundImage: "url(" + require("assets/img/landing-background.png") + ")",
          }}
        ></div>
        <div className="content">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto" md="6">
                <Card className="card-login card-plain">
                  <Form action="" className="form" method="">
                    <CardHeader className="text-center">
                      <div>
                        <img alt="..." src={logo} style={{ height: "150px", width: "150px" }}></img>
                      </div>
                    </CardHeader>
                    <CardBody>
                      <InputGroup className={"no-border input-lg" + (firstFocus ? " input-group-focus" : "")}>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            {/* <i className="now-ui-icons users_circle-08"></i> */}
                            <i className="fas fa-user"></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          autoFocus
                          id="username"
                          name="username"
                          placeholder="Ingrese su usuario"
                          type="text"
                          onChange={handleChange}
                          onFocus={() => setFirstFocus(true)}
                          onBlur={() => setFirstFocus(false)}
                          value={data.username}
                        ></Input>
                      </InputGroup>
                      <InputGroup className={"no-border input-lg" + (lastFocus ? " input-group-focus" : "")}>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            {/* <i className="now-ui-icons text_caps-small"></i> */}
                            <i className="fas fa-key"></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          input="password"
                          name="password"
                          placeholder="Contraseña"
                          type="password"
                          onKeyPress={handleKeyPress}
                          onChange={handleChange}
                          onFocus={() => setLastFocus(true)}
                          onBlur={() => setLastFocus(false)}
                          value={data.password}
                        ></Input>
                      </InputGroup>
                    </CardBody>
                    <CardFooter className="text-center">
                      <Button block className="btn-round btn-arhock" onClick={(event) => doLogin(event)} size="lg">
                        Ingresar
                      </Button>
                    </CardFooter>
                    <div className="pull-left">
                      {/* <h6>
                        <a className="link footer-link" href="#pablo" onClick={(e) => e.preventDefault()}>
                          Create Account
                        </a>
                      </h6> */}
                    </div>
                    {/* 
                    <div className="pull-right">
                      <h6>
                        <a
                          className="link footer-link clickable"
                          onClick={(event) => {
                            forgotPassword(event);
                          }}
                        >
                          Olvidé mi contraseña
                        </a>
                      </h6>
                    </div>
                            */}
                  </Form>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>

        {/* 
        <Row className="main-container align-items-center ">
          <Col className="card-col mx-auto" lg="4" md="6">
            <Card className="card-register blue">
              <h3 className="title login-title mx-auto ">
                <strong>Ingreso</strong>
              </h3>
              <Form
                onSubmit={(event) => {
                  doLogin(event);
                }}
              >
                <div>Login Page</div>
                <div>
                  <input autoFocus id="username" name="username" placeholder="Ingrese su e-mail" onChange={handleChange} value={data.username} />
                </div>
                <div>
                  <input id="password" name="password" placeholder="Contraseña" onChange={handleChange} onKeyPress={handleKeyPress} value={data.password} />
                </div>
                <div>
                  <button onClick={(event) => doLogin(event)}> Ingresar</button>
                </div>
              </Form>
              <div className="forgot">
                <button
                  className=" btn-forgot"
                  onClick={(event) => {
                    forgotPassword(event);
                  }}
                >
                  Olvidé mi contraseña
                </button>
              </div>
            </Card>
          </Col>
        </Row> */}
      </div>
    </>
  );
};

export default Login;
